import {
  LoginRequest,
  LoginResponse,
  SignUpRequest,
  SignUpResponse,
  ConfirmSignUpRequest,
  ConfirmSignUpResponse,
  RefreshTokenRequest,
  RefreshTokenResponse,
  ResetPasswordRequest,
  ResendOtpRequest,
} from "types/authTypes";
import { baseApi } from "./baseApi";
import { SettingsJson, SettingsType } from "types/globalTypes";

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (credentials) => ({
        url: "/auth/login",
        method: "POST",
        body: credentials,
      }),
      invalidatesTags: ["Auth"],
    }),

    signUp: builder.mutation<SignUpResponse, SignUpRequest>({
      query: (userData) => ({
        url: "/auth/sign-up",
        method: "POST",
        body: userData,
      }),
      invalidatesTags: ["Auth"],
    }),

    confirmSignUp: builder.mutation<
      ConfirmSignUpResponse,
      ConfirmSignUpRequest
    >({
      query: (data) => ({
        url: "/auth/sign-up/confirm",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Auth"],
    }),

    refreshToken: builder.mutation<RefreshTokenResponse, RefreshTokenRequest>({
      query: (data) => ({
        url: "/auth/refresh",
        method: "POST",
        body: data,
      }),
    }),

    resetPassword: builder.mutation<void, string>({
      query: (mobile) => ({
        url: `/auth/reset-password/request/${mobile}`,
        method: "POST",
      }),
      invalidatesTags: ["Auth"],
    }),

    resetPasswordConfirm: builder.mutation<void, ResetPasswordRequest>({
      query: (data) => ({
        url: "/auth/reset-password/confirm",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Auth"],
    }),

    resendOtp: builder.mutation<void, ResendOtpRequest>({
      query: (data) => ({
        url: `/auth/resend-token?mobile=${data.mobile}&type=${data.type}`,
        method: "POST",
      }),
      invalidatesTags: ["Auth"],
    }),

    logout: builder.mutation<void, void>({
      query: () => ({
        url: "/auth/logout",
        method: "POST",
      }),
      invalidatesTags: ["Auth"],
    }),

    // settings
    getSettings: builder.query<SettingsType, void>({
      query: () => `/settings`,
      providesTags: ["Settings"],
    }),

    updateSettings: builder.mutation<SettingsType, SettingsJson>({
      query: (data) => {
        return {
          url: `/settings`,
          method: "POST",
          body: {
            settingsJson: data,
          },
        };
      },
      invalidatesTags: ["Settings"],
    }),
  }),
});

export const {
  useLoginMutation,
  useSignUpMutation,
  useConfirmSignUpMutation,
  useRefreshTokenMutation,
  useResetPasswordMutation,
  useResetPasswordConfirmMutation,
  useResendOtpMutation,
  useLogoutMutation,
  // settings
  useGetSettingsQuery,
  useUpdateSettingsMutation,
} = authApi;
